import { SocialRewardCampaign } from '@/models/social-rewards';

export class RootStateSocialRewards {
  constructor(
    public socialRewardCampaign: SocialRewardCampaign[] = [],
    public webSiteUrl?: string
  ) {}
}
